



















































































































































import { Component } from 'vue-property-decorator'
import { sessionStorage } from '@ustra/core/src/utils/storage/session-storage'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import pushService from '../../service/push-service'
import { SetPushNotification } from '~/model/co/push-noti-model'
import pushSettingEventBus from '~/event-bus/push-setting-event-bus'

@Component({
  name: 'PushNotificationSetting',
})
export default class extends HsComponent {
  syncVisible: boolean = false
  type: string = ''

  pushNotiSetting: SetPushNotification = {
    pushNotfYn: 'Y',
    adNotiYn: 'Y',
    infNotiYn: 'Y',
    oshpYn: 'Y',
    wtdwYn: 'Y',
    itemInqrYn: 'Y',
    refYn: 'Y',
    dreamCsYn: 'Y',
    stlYn: 'Y',
    inqrAnswYn: 'Y',
    incncsCont: 'Y',
  }

  mounted() {
    pushSettingEventBus.on((state) => {
      this.callApiSelectPushAdmin()

      this.type = state.type
      this.syncVisible = true
    })
  }

  onClickSettingConfirm(e) {
    if (e === true) {
      this.callApiMergePushAdmin()
    }
    if (this.type === 'native') {
      console.log('앱 설정 호출')
      this.$ustra.mobile.bridge.callNative({
        id: 'IF_COMMON',
        data: {
          type: '02',
        },
      })
    }
  }

  onChangeAllSwitch() {
    const val = this.pushNotiSetting.pushNotfYn

    this.pushNotiSetting = {
      pushNotfYn: val,
      adNotiYn: val,
      infNotiYn: val,
      oshpYn: val,
      wtdwYn: val,
      itemInqrYn: val,
      refYn: val,
      dreamCsYn: val,
      stlYn: val,
      inqrAnswYn: val,
      incncsCont: val,
    }
  }

  onChangeSwitch() {
    const mergeVal =
      this.pushNotiSetting.oshpYn +
      this.pushNotiSetting.wtdwYn +
      this.pushNotiSetting.itemInqrYn +
      this.pushNotiSetting.refYn +
      this.pushNotiSetting.dreamCsYn +
      this.pushNotiSetting.stlYn +
      this.pushNotiSetting.inqrAnswYn +
      this.pushNotiSetting.incncsCont

    if (mergeVal === 'NNNNNNNN') {
      this.pushNotiSetting.pushNotfYn = 'N'
    } else if (mergeVal.includes('Y')) {
      this.pushNotiSetting.pushNotfYn = 'Y'
    }
  }

  // 기존 설정값
  async callApiSelectPushAdmin() {
    const result = await pushService.getPushAdmin()

    if (result?.data?.resultCode === '0000') {
      this.pushNotiSetting = { ...result.data.body }
    }
  }

  // 설정 변경
  async callApiMergePushAdmin() {
    const result = await pushService.setPushAdmin(this.pushNotiSetting)

    if (result?.data?.resultCode === '0000') {
      sessionStorage.setItem('IS_ALARM_SET', true)
    }
  }
}
